<template lang="pug">
  b-modal(id="reports-modal", :title="title", hide-footer)
    div
      h5 Expenses
      div(v-if='report && report.sumExpenses')
        .item(v-for='item in Object.keys(report.sumExpenses)')
          strong {{ item }}
          span ${{report.sumExpenses[item]}}
      div
        strong Total
        strong ${{report.totalExpenses}}
    div
      h5 Revenues
      div(v-if='report && report.sumRevenues')
        .item(v-for='item in Object.keys(report.sumRevenues)')
          strong {{item}}
          span ${{report.sumRevenues[item]}}
      div
        strong Total
        strong ${{report.totalRevenues}}
    div
      h5 Profit ${{report.profit}}
    .d-flex.justify-content-center
      button.btn.btn-primary(@click='closeModal()') Close
</template>

<style lang="scss" scoped>
  h5 {
    margin-top: 1rem;
  }

  strong {
    display: inline-block;
    width: 150px;
  }
</style>

<script>
export default {
  data () {
    return {
      report: {}
    }
  },
  mounted () {
    this.$root.$on('smallbiz-show-report', (data) => {
      this.report = data
      this.$root.$emit('bv::show::modal', 'reports-modal')
    })
  },
  destroyed () {
    this.$root.$off('smallbiz-show-report')
  },
  computed: {
    title () {
      return `${this.report.type} ${this.report.startDate}`
    }
  },
  methods: {
    closeModal () {
      this.$root.$emit('bv::hide::modal', 'reports-modal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ReportsModal.vue